<template>
  <div
    class="hr-loader-block"
    :class="{
      'hr-loader-block--transparent': transparent,
      'hr-loader-block--solid': solid,
      'hr-loader-block--translucent': translucent,
    }"
    :style="style"
  >
    <img
      src="../assets/images/circle-spinner.png"
      class="hr-loader-block__icon"
    />
    <p v-if="text">{{ text }}</p>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'hr-loader-block',
  props: {
    transparent: {
      type: Boolean,
      default: false,
    },
    solid: {
      type: Boolean,
      default: false,
    },
    translucent: {
      type: Boolean,
      default: false,
    },
    style: {
      type: Object,
      default: () => ({}),
    },
    text: {
      type: String,
      default: '',
    },
  },
});
</script>

<style scoped>
@keyframes rotate2 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.hr-loader-block {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: var(--dpt-space-600);
  flex-direction: column;
  margin: auto;
  overflow: hidden;
  background-color: rgba(var(--co-background-primary-rgb), 0.75);
  background-position: center;
  border-radius: 4px;
}

.hr-loader-block__icon {
  width: 50px;
  height: 50px;
  margin-right: auto;
  margin-left: auto;
  animation: rotate2 1s linear infinite;
}

.hr-loader-block--transparent {
  background: transparent;
}

.hr-loader-block--solid {
  background: var(--dpt-surface-color);
}

.hr-loader-block--translucent {
  background: var(--dpt-surface-color);
  opacity: 0.75;
}
</style>
